import { useQuery } from '@tanstack/react-query';
import { api } from 'lib/request/api';
import type { TypeCurveListingRow } from 'types/api-responses';

interface TypeCurveHeadersSearchResult {
  results: TypeCurveListingRow[];
  totalCount: number;
}

export function useTypeCurveHeaders(
  typeCurveAreaName: string,
  active?: boolean
) {
  return useQuery<TypeCurveHeadersSearchResult, Error>({
    queryKey: ['tc-dca-type-curve-headers', typeCurveAreaName, active],
    queryFn: ({ signal }) =>
      api
        .post('queries/type_curve_headers', {
          json: {
            page: 1,
            pageSize: 100,
            typeCurveAreaName,
            ...(active !== undefined && { active }),
            sortAttribute: 'last_qc_date',
            sortDirection: 'DESC',
          },
          signal,
        })
        .json<TypeCurveHeadersSearchResult>(),
    staleTime: 300_000,
    enabled: !!typeCurveAreaName,
  });
}
